/**
 * SweetAlert2 Theme Configuration
 * Provides consistent theming for SweetAlert dialogs based on current theme
 */

/**
 * Get the current theme from localStorage or document attribute
 */
const getCurrentTheme = () => {
  // First check localStorage
  const stored = localStorage.getItem('taxify-theme');
  if (stored) return stored;

  // Fallback to document attribute
  const docTheme = document.documentElement.getAttribute('data-theme');
  return docTheme || 'light';
};

const isDarkTheme = () => getCurrentTheme() === 'dark';

/**
 * Get SweetAlert theme configuration
 */
export const getSwalTheme = () => {
  const isDark = isDarkTheme();

  return {
    background: isDark ? '#242424' : '#FFFFFF',
    color: isDark ? '#FFFFFF' : '#1A1815',
    confirmButtonColor: '#F7B731',
    cancelButtonColor: isDark ? '#3D3D3D' : '#E5E1D8',
    iconColor: undefined, // Use default icon colors
  };
};

export const getSwalSuccessTheme = () => ({
  ...getSwalTheme(),
  iconColor: '#22C55E',
});

export const getSwalErrorTheme = () => ({
  ...getSwalTheme(),
  iconColor: '#EF4444',
});

/**
 * Get themed SweetAlert configuration for question/confirm dialogs
 */
export const getSwalConfirmTheme = () => ({
  ...getSwalTheme(),
  confirmButtonColor: '#F7B731',
  cancelButtonColor: isDarkTheme() ? '#3D3D3D' : '#D4CFC4',
});

export default getSwalTheme;
